(ns dre.widgets.demographics.views
  (:require
   [dre.components.widget.views :as widget-base]
   [dre.components.widget.views.common :refer [no-result title-with-filter]]
   [dre.components.widget.views.table-list :refer [table-list]]
   [dre.widgets.demographics.events :as-alias events]
   [re-frame.core :as rf]))
  
(defn widget-content
  [data]
  (fn []
    [:<>
     (if (not (seq data))
       [no-result true]
       [table-list "demographics-table" data {:sort-fn :idx}])]))

(defn view
  [id title]
  (let [state @(rf/subscribe [::events/state])
        data @(rf/subscribe [::events/data])
        loading? (= :loading (:state state))]
    [widget-base/view id [title-with-filter title id] [widget-content data]
     {:csv-event [::events/export]
      :export-image? false}
     {:loading? loading?}]))